<form [formGroup]="searchGroup">
  <div class="input-field">
    <i aria-hidden="true" class="fal fa-search"></i>
    <input #searchInput type="text" name="qsWord" formControlName="qsWord"
      placeholder="{{'PLACEHOLDER.QUICKSEARCH' | translate}}" />
      @if (!empty) {
        <i aria-hidden="true" class="reset fal fa-times" (click)="resetSearch()"></i>
      }
    </div>
  </form>
